import axios from "./axios";
import Vue from "vue";
import store from "@/store/index";
import router from "@/router";
let instance = axios();

export default {
  async get({ url, params, headers, errorFn, loadingText }) {
    let options = {};
    if (params) {
      options.params = params;
    }
    if (headers) {
      options.headers = headers;
    }
    try {
      store.commit("global/setLoading", { flag: true, title: loadingText });
      let result = await instance.get(url, options);
      store.commit("global/setLoading", { flag: false });
      return result;
    } catch (error) {
      store.commit("global/setLoading", { flag: false });
      console.log("get error", error);
      if (error && error.code === "invalidtoken") {
        errorFn = function() {
          router.replace("/");
        };
      }
      Vue.prototype.$throw({ error, errorFn });
    }
  },
  async post({
    url,
    params,
    headers,
    data,
    errorFn,
    showLoading = true,
    loadingText,
    progressCb
  }) {
    let options = {};
    if (params) {
      options.params = params;
    }
    if (headers) {
      options.headers = headers;
    }
    let formData = new FormData();
    formData.append("wstoken", store.state.auth.userinfo.wstoken);
    formData.append("moodlewsrestformat", "json");
    for (const key of Object.keys(data)) {
      formData.append(key, data[key]);
    }
    try {
      if (showLoading) { store.commit("global/setLoading", { flag: true, title: loadingText }); }
      let result = await instance({
        method: "post",
        url,
        data: formData,
        options,
        onUploadProgress(progress) {
          // console.log(
          //   Math.round((progress.loaded / progress.total) * 100).toFixed(0)
          // );
          progressCb(
            Math.round((progress.loaded / progress.total) * 100).toFixed(0)
          );
        }
      });
      if (showLoading) store.commit("global/setLoading", { flag: false });
      return result;
    } catch (error) {
      store.commit("global/setLoading", { flag: false });
      console.log("get error", error);
      if (error && error.code === "invalidtoken") {
        errorFn = function() {
          router.replace("/");
        };
      }
      Vue.prototype.$throw({ error, errorFn });
    }
  },
  put(url, params, headers) {
    let options = {};

    if (headers) {
      options.headers = headers;
    }
    return instance.put(url, params, options);
  },
  delete(url, params, headers) {
    let options = {};

    if (params) {
      options.params = params;
    }
    if (headers) {
      options.headers = headers;
    }
    return instance.delete(url, options);
  }
};
